// extracted by mini-css-extract-plugin
export default {"mobile-date-field":"VTyRaO","mobileDateField":"VTyRaO","desktop-date-field":"WNxT9s","desktopDateField":"WNxT9s"};